/* eslint eqeqeq: "off" */

import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Divider,
  Input,
  Row,
  Select,
  Modal,
  Tooltip,
  Radio,
  Typography,
  // Badge,
  // Table,
  Image,
  Switch,
  Spin,
} from "antd";
import noTransaction from "../../assets/images/no-transaction.png";
import {
  PlusOutlined,
  EditOutlined,
  ShareAltOutlined,
  BankOutlined,
  EyeInvisibleOutlined,
  MinusOutlined,
} from "@ant-design/icons";
import "./index.css";
import { isEmpty, parseInt } from "lodash";
import DatePicker from "react-datepicker";
import { BiCalendar, BiDownload } from "react-icons/bi";
import moment from "moment";
import {
  loadAccountTransactionList,
  loadCashBankList,
  loadCashBankTotalList,
  loadCashInHandList,
  loadCashInHandTransaction,
  loadTotalCashBankTransaction,
} from "../../store/cash-bank/actions";
import { useDispatch, useSelector } from "react-redux";
import useMedia from "use-media-antd-query";
import api from "../../helpers";
import { toast, ToastContainer } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import {
  loadPartyAccountList,
  loadPaymentInListRecordsMetaData,
} from "../../store/payment-in/actions";
// const { Dragger } = Upload;
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { loadPrefixSettingsList } from "../../store/expenses/actions";

const CasbBank = () => {
  const dispatch = useDispatch();
  const media = useMedia();
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  //user details from login
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const organizationId = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const createdById = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";
  const salesPrefixList = {
    organizationId: organizationId,
    isType: "isExpense",
  };

  useEffect(() => {
    dispatch(
      loadCashBankTotalList({
        organizationId: organizationId,
      })
    );
    dispatch(loadPrefixSettingsList(salesPrefixList));
    dispatch(
      loadCashInHandList({
        organizationId: organizationId,
      })
    );
    dispatch(
      loadTotalCashBankTransaction({
        organizationId: organizationId,
      })
    );
    dispatch(
      loadCashBankList({
        organizationId: organizationId,
      })
    );
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //reducer state

  const {
    cash_bank_details = [],
    cash_bank_total = [],
    total_cash_bank = [],
    cash_in_hand_details = [],
    cash_hand_list = [],
    account_transaction_list = [],
  } = useSelector((state) => state.CashBank);

  const { recordsMetaData = {} } = useSelector((state) => state.PaymentIn);
  const { prefix_settings_list = [] } = useSelector((state) => state.Expenses);
  const { party_account_list = [] } = useSelector((state) => state.PaymentIn);
  console.log(account_transaction_list, "account_transaction_list");

  const [addMoneyModal, setAddMoneyModal] = useState(false);
  const [selectedBankLoad, setSelectedBankLoad] = useState(false);
  const [selectedCashInLoad, setSelectedCashInLoad] = useState(false);
  // const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(
    "Unlinked Transactions"
  );
  //adjust stock
  const [addMoneyIn, setAddMoneyIn] = useState([]);
  const [accountDetails, setAccountDetails] = useState([]);
  const [totalTransactionRows, setTotalTransactionRows] = useState([]);
  const [totalCashTransactionRows, setTotalCashTransactionRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cashBankLoad, setCashBankLoad] = useState(false);
  const [fromDate, setFromDate] = useState(false);
  const [toDate, setToDate] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Select Options");

  useEffect(() => {
    if (total_cash_bank && total_cash_bank.length > 0) {
      setTotalTransactionRows(total_cash_bank);
      setCashBankLoad(!cashBankLoad);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total_cash_bank]);
  useEffect(() => {
    if (cash_in_hand_details && cash_in_hand_details.length > 0) {
      setTotalCashTransactionRows(cash_in_hand_details);
      setCashBankLoad(!cashBankLoad);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cash_in_hand_details]);

  console.log(totalTransactionRows, "totalTransactionRows");

  const partyAccountOptions =
    party_account_list && party_account_list.length > 0
      ? party_account_list.map((data) => {
          return {
            accountName: data.accountName,
            openingBalance: data.openingBalance,
            asOfDate: data.asOfDate,
            accountNumber: data.accountNumber,
            bankName: data.bankName,
            bankBranch: data.bankBranch,
            ifscCode: data.ifscCode,
            accountHolderName: data.accountHolderName,
            upiId: data.upiId,
            label:
              data.accountNumber == "" && !isEmpty(data.accountName) ? (
                <h1 className="text-[12px] text-[#4096ffba]">
                  {data.accountName}
                </h1>
              ) : !isEmpty(data.accountNumber) && !isEmpty(data.accountName) ? (
                <>
                  <h1 className="text-[12px]">{data.accountName}</h1>
                  <p className="text-[12px] text-[#4096ffba] mt-[-7px]">
                    {data.accountNumber}
                  </p>
                </>
              ) : (
                ""
              ),
            value: data._id,
          };
        })
      : [];
  const partyAccountList =
    partyAccountOptions && partyAccountOptions.length > 0
      ? partyAccountOptions.filter(
          (data) => data.accountName !== ""
          // && data.accountNumber !== ""
        )
      : [];
  //Transaction details

  //purchase rows

  const [transactionRows, setTransactionRows] = useState([
    {
      _id: "",
      key: "",
      accountId: "",
      isCash: "",
      mode: "",
      paidAmount: "",
      balanceAmount: "",
      partyName: "",
      paymentDate: "",
      paymentModeId: "",
      paymentNo: "",
      receivedAmount: "",
      transActionType: "",
      transActionTypeId: "",
      createdAt: "",
      createdBy: "",
    },
  ]);

  console.log(transactionRows, "transactionRows");

  //data table
  const transactionDataTable =
    account_transaction_list && account_transaction_list.length > 0
      ? account_transaction_list.map((data, index) => {
          return {
            _id: data._id,
            key: index + 1,
            accountId: data.accountId,
            isCash: data.isCash,
            mode: data.mode,
            paidAmount: data.paidAmount,
            balanceAmount: data.balanceAmount,
            partyName: data.partyName,
            paymentDate: data.paymentDate,
            paymentModeId: data.paymentModeId,
            paymentNo: data.paymentNo,
            receivedAmount: data.receivedAmount,
            transActionType: data.transActionType,
            transActionTypeId: data.transActionTypeId,
            createdAt: data.createdAt,
            createdBy: data.createdBy,
          };
        })
      : [];

  useEffect(() => {
    if (transactionDataTable && transactionDataTable.length > 0) {
      setTransactionRows(transactionDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account_transaction_list]);

  //select days options start
  const options = [
    "Lifetime",
    "Today",
    "Yesterday",
    "This Week",
    "Last 7 days",
    "Last Week",
    "This Month",
    "Last 30 days",
    "Last Month",
    "Custom Range",
  ];
  const filterDataByDate = (filter) => {
    const bankAccountTransactionRows =
      selectedTransaction == "Cash in hand" &&
      cash_in_hand_details &&
      cash_in_hand_details.length > 0
        ? cash_in_hand_details
        : selectedTransaction == "Savings" &&
          account_transaction_list &&
          account_transaction_list.length > 0
        ? account_transaction_list
        : total_cash_bank && total_cash_bank.length > 0
        ? total_cash_bank
        : [];
    const currentDate = new Date();

    let filteredData = bankAccountTransactionRows;

    if (filter === "Today") {
      filteredData = bankAccountTransactionRows.filter((item) => {
        const itemDate = new Date(item.paymentDate);
        return itemDate.toDateString() === currentDate.toDateString();
      });
    } else if (filter === "Yesterday") {
      filteredData = bankAccountTransactionRows.filter((item) => {
        const itemDate = new Date(item.paymentDate);
        const yesterday = new Date(currentDate);
        yesterday.setDate(currentDate.getDate() - 1);
        return itemDate.toDateString() === yesterday.toDateString();
      });
    } else if (filter === "This Week") {
      const startOfWeek = new Date(currentDate);
      startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());
      filteredData = bankAccountTransactionRows.filter((item) => {
        const itemDate = new Date(item.paymentDate);
        return itemDate >= startOfWeek && itemDate <= currentDate;
      });
    } else if (filter === "Last 7 days") {
      const last7Days = new Date(currentDate);
      last7Days.setDate(currentDate.getDate() - 7);
      filteredData = bankAccountTransactionRows.filter((item) => {
        const itemDate = new Date(item.paymentDate);
        return itemDate >= last7Days && itemDate <= currentDate;
      });
    } else if (filter === "Last Week") {
      const startOfThisWeek = new Date(currentDate);
      startOfThisWeek.setDate(currentDate.getDate() - currentDate.getDay());
      const startOfLastWeek = new Date(startOfThisWeek);
      startOfLastWeek.setDate(startOfThisWeek.getDate() - 7);

      const endOfLastWeek = new Date(startOfThisWeek);
      endOfLastWeek.setDate(startOfThisWeek.getDate() - 1);

      filteredData = bankAccountTransactionRows.filter((item) => {
        const itemDate = new Date(item.paymentDate);
        return itemDate >= startOfLastWeek && itemDate <= endOfLastWeek;
      });
    } else if (filter === "This Month") {
      const startOfMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      filteredData = bankAccountTransactionRows.filter((item) => {
        const itemDate = new Date(item.paymentDate);
        return itemDate >= startOfMonth && itemDate <= currentDate;
      });
    } else if (filter === "Last Month") {
      const startOfLastMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 1,
        1
      );
      const endOfLastMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        0
      );
      filteredData = bankAccountTransactionRows.filter((item) => {
        const itemDate = new Date(item.paymentDate);
        return itemDate >= startOfLastMonth && itemDate <= endOfLastMonth;
      });
    } else if (filter === "Last 30 days") {
      const last30Days = new Date(currentDate);
      last30Days.setDate(currentDate.getDate() - 30);
      filteredData = bankAccountTransactionRows.filter((item) => {
        const itemDate = new Date(item.paymentDate);
        return itemDate >= last30Days && itemDate <= currentDate;
      });
    } else if (filter === "Custom Range") {
      console.log("Custom Range");
      if (!fromDate || !toDate) {
        console.error(
          "Custom Range requires both fromDate and toDate to be set"
        );
        return;
      }

      const from = new Date(fromDate);
      const to = new Date(toDate);

      if (isNaN(from.getTime()) || isNaN(to.getTime())) {
        console.error("Invalid date format for Custom Range");
        return;
      }

      filteredData = bankAccountTransactionRows.filter((item) => {
        const itemDate = new Date(item.paymentDate);
        return itemDate >= from && itemDate <= to;
      });
    }
    console.log(filteredData, "filteredData");
    if (selectedTransaction == "Cash in hand") {
      setTotalCashTransactionRows(
        filteredData.map((item) => ({
          paymentDate: item.paymentDate,
          balanceAmount: item.balanceAmount,
          createdAt: item.createdAt,
          createdBy: item.createdBy,
          isCash: item.isCash,
          mode: item.mode,
          paidAmount: item.paidAmount,
          partyName: item.partyName,
          paymentModeId: item.paymentModeId,
          paymentNo: item.paymentNo,
          receivedAmount: item.receivedAmount,
          transActionType: item.transActionType,
          transActionTypeId: item.transActionTypeId,
          updatedAt: item.updatedAt,
          _id: item._id,
        }))
      );
      setSelectedCashInLoad(true);
      setTimeout(() => {
        setSelectedCashInLoad(false);
      }, 1000);
    } else if (selectedTransaction == "Savings") {
      setTransactionRows(
        filteredData.map((item, index) => ({
          paymentDate: item.paymentDate,
          key: index + 1,
          accountId: item.accountId,
          balanceAmount: item.balanceAmount,
          createdAt: item.createdAt,
          createdBy: item.createdBy,
          isCash: item.isCash,
          mode: item.mode,
          paidAmount: item.paidAmount,
          partyName: item.partyName,
          paymentModeId: item.paymentModeId,
          paymentNo: item.paymentNo,
          receivedAmount: item.receivedAmount,
          transActionType: item.transActionType,
          transActionTypeId: item.transActionTypeId,
          updatedAt: item.updatedAt,
          _id: item._id,
        }))
      );
      setSelectedBankLoad(true);
      setTimeout(() => {
        setSelectedBankLoad(false);
      }, 1000);
    } else {
      setTotalTransactionRows(
        filteredData.map((item) => ({
          paymentDate: item.paymentDate,
          balanceAmount: item.balanceAmount,
          createdAt: item.createdAt,
          createdBy: item.createdBy,
          isCash: item.isCash,
          mode: item.mode,
          paidAmount: item.paidAmount,
          partyName: item.partyName,
          paymentModeId: item.paymentModeId,
          paymentNo: item.paymentNo,
          receivedAmount: item.receivedAmount,
          transActionType: item.transActionType,
          transActionTypeId: item.transActionTypeId,
          updatedAt: item.updatedAt,
          _id: item._id,
        }))
      );
    }
  };

  const handleOptionSelect = (event) => {
    const option = event.target.value;
    setSelectedOption(option);

    if (option === "Custom Range") {
      setIsModalOpen(true);
    } else {
      filterDataByDate(option);
    }
  };

  const handleApply = () => {
    if (fromDate && toDate) {
      setSelectedOption(`${fromDate} - ${toDate}`);
      setIsModalOpen(false);
      filterDataByDate("Custom Range");
      setSelectedOption("Custom Range");
    }
  };
  //end

  const [adjustBalanceData, setAdjustBalanceData] = useState({
    adjustAmount: "",
    currentBalance: "",
    adjustRemarks: "",
    paymentModeId: "",
    // currentBalance: "",
  });
  const [adjustMode, setAdjustMode] = useState("Add");
  const [copiedText, setCopiedText] = useState("");
  // const [selectedText, setSelectedText] = useState("");
  const [selectMode, setSelectMode] = useState("");
  const [adjustDate, setAdjustDate] = useState("");

  const handleAdjustChange = (e) => {
    const { name, value } = e.target;

    const validationRules = {
      // mobileNumber: /^[0-9]*$/, // Only numeric characters allowed
      adjustAmount: /^[0-9]\d*\.?\d*$/,
    };
    if (validationRules[name]) {
      if (validationRules[name].test(value) || value === "") {
        setAdjustBalanceData({
          ...adjustBalanceData,
          [name]: value,
        });
      }
    } else {
      setAdjustBalanceData({
        ...adjustBalanceData,
        [name]: value,
      });
    }
  };
  const adjustAmount = parseInt(adjustBalanceData.adjustAmount);
  console.log(adjustBalanceData, "adjustBalanceData");

  //Transaction states

  const [selectedBankAccount, setSelectedBankAccount] = useState({
    _id: "",
    accountName: "",
    accountHolderName: "",
    accountNumber: "",
    ifscCode: "",
    bankName: "",
    bankBranch: "",
    upiId: "",
    openingBalance: "",
    currentBalance: "",
    paymentModeName: "",
    paymentModeId: "",
  });

  const [shareAccountModal, setShareAccountModal] = useState(false);
  const [addBankModal, setAddBankModal] = useState(false);
  const [updateBankModal, setUpdateBankModal] = useState(false);
  const [bankMode, setBankMode] = useState("");
  const [accountId, setAccountId] = useState("");

  const [bankData, setBankData] = useState({
    accountName: "",
    openingBalance: "",
    currentBalance: "",
    accountNumber: "",
    reAccountNumber: "",
    ifscCode: "",
    bankName: "",
    bankBranchName: "",
    accountHoldersName: "",
    upiId: "",
    _id: "",
  });

  const handleBankChange = (e) => {
    setBankData({
      ...bankData,
      [e.target.name]: e.target.value,
    });
  };
  console.log(selectedBankAccount, "selectedBankAccount");
  console.log(accountId, "accountId");
  const [isBankButtonDisabled, setIsBankButtonDisabled] = useState(false);

  //add bank
  const createBankDetails = () => {
    if (simpleValidator.current.allValid()) {
      setIsBankButtonDisabled(true);
      setTimeout(() => {
        setIsBankButtonDisabled(false);
      }, 6000);
      const bankDetails = {
        organizationId: organizationId,
        accountName: bankData.accountName,
        openingBalance: parseInt(bankData.openingBalance),
        asOfDate: asOfDate ? moment(asOfDate).format("YYYY-MM-DD") : "",
        accountNumber: bankData.accountNumber,
        bankName: bankData.bankName,
        bankBranch: bankData.bankBranchName,
        ifscCode: bankData.ifscCode,
        accountHolderName: bankData.accountHoldersName,
        upiId: bankData.upiId,
        createdBy: createdById,
      };

      api
        .post("/org/addbankaccount", bankDetails)
        .then((res) => {
          setUpdateBankModal(false);
          toast.success("Bank details added succesfully");
          dispatch(
            loadCashBankList({
              organizationId: organizationId,
            })
          );
          dispatch(
            loadTotalCashBankTransaction({
              organizationId: organizationId,
            })
          );
          dispatch(
            loadAccountTransactionList({
              organizationId: organizationId,
              accountId: selectedBankAccount._id,
            })
          );
          dispatch(
            loadPartyAccountList({
              organizationId: organizationId,
            })
          );
          dispatch(
            loadCashBankTotalList({
              organizationId: organizationId,
            })
          );
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(errorMsg || `An Error occured while adding the bank`);
          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      setUpdateBankModal(true);
    }
  };

  //add bank
  const updateBankDetails = () => {
    if (simpleValidator.current.allValid()) {
      setIsBankButtonDisabled(true);
      setTimeout(() => {
        setIsBankButtonDisabled(false);
      }, 6000);
      const bankDetails = {
        accountId: bankData._id,
        organizationId: organizationId,
        accountName: bankData.accountName,
        openingBalance: parseInt(bankData.openingBalance),
        currentBalance: parseInt(bankData.currentBalance),
        asOfDate: asOfDate ? moment(asOfDate).format("YYYY-MM-DD") : "",
        accountNumber: bankData.accountNumber,
        bankName: bankData.bankName,
        bankBranch: bankData.bankBranchName,
        ifscCode: bankData.ifscCode,
        accountHolderName: bankData.accountHoldersName,
        upiId: bankData.upiId,
        updatedBy: createdById,
      };

      api
        .put("/org/updatebankaccount", bankDetails)
        .then((res) => {
          setUpdateBankModal(false);
          console.log(res.data, "response");
          setSelectedBankAccount({
            _id: res.data.data._id,
            accountName: res.data.data.accountName,
            accountHolderName: res.data.data.accountHolderName,
            accountNumber: res.data.data.accountNumber,
            ifscCode: res.data.data.ifscCode,
            bankName: res.data.data.bankName,
            bankBranch: res.data.data.bankBranch,
            upiId: res.data.data.upiId,
            openingBalance: res.data.data.openingBalance,
            currentBalance: res.data.data.currentBalance,
          });
          toast.success("Bank details updated succesfully");
          dispatch(
            loadCashBankList({
              organizationId: organizationId,
            })
          );
          dispatch(
            loadTotalCashBankTransaction({
              organizationId: organizationId,
            })
          );
          dispatch(
            loadAccountTransactionList({
              organizationId: organizationId,
              accountId: selectedBankAccount._id,
            })
          );
          dispatch(
            loadPartyAccountList({
              organizationId: organizationId,
            })
          );
          dispatch(
            loadCashBankTotalList({
              organizationId: organizationId,
            })
          );

          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          console.log(error, "errorMsg");
          toast.error(errorMsg || `An Error occured while adding the bank`);

          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      setUpdateBankModal(true);
    }
  };

  const newBalance =
    !isEmpty(adjustBalanceData.adjustAmount) && adjustMode === "Reduce"
      ? parseInt(adjustBalanceData.currentBalance) - adjustAmount
      : !isEmpty(adjustBalanceData.adjustAmount) && adjustMode === "Add"
      ? adjustAmount + adjustBalanceData.currentBalance
      : "";

  console.log(newBalance, "newBalance");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [validations, setValidations] = useState(false);

  console.log(adjustDate, "adjustDate");
  //add or reduce money
  const addOrReduceMoneyDetails = () => {
    if (
      !isEmpty(addMoneyIn) &&
      adjustBalanceData.adjustAmount &&
      adjustBalanceData.paymentModeId !== "66c9bd5ab3fca462ca48a87e" &&
      addMoneyIn !== "Cash" &&
      (isEmpty(accountDetails) || accountDetails.length == 0)
    ) {
      const bankDetails = {
        isAdd: adjustMode === "Add" ? true : false,
        isReduce: adjustMode === "Reduce" ? true : false,
        enterPaymentAmount: parseInt(adjustBalanceData.adjustAmount),
        // if  bank account select means add  accountId
        accountId:
          addMoneyIn === "66c9bd5ab3fca462ca48a87e"
            ? ""
            : accountDetails.length == 0
            ? ""
            : accountId
            ? accountId
            : accountDetails,

        paymentDate: adjustDate ? moment(adjustDate).format("YYYY-MM-DD") : "",
        createdBy: createdById,
        paymentModeId: adjustBalanceData.paymentModeId
          ? adjustBalanceData.paymentModeId
          : addMoneyIn,
        organizationId: organizationId,
      };
      setIsButtonDisabled(true);

      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 3000);
      const bankDetailsObj = Object.keys(bankDetails).forEach(
        (key) =>
          (bankDetails[key] === "" || bankDetails[key] === undefined) &&
          delete bankDetails[key]
      );
      console.log(bankDetailsObj, "bankDetailsObj");
      api
        .post("/org/addorreducemoney", bankDetails)
        .then((res) => {
          setAddMoneyModal(false);
          toast.success("Money Values adjusted succesfully");
          setAdjustBalanceData({
            currentBalance: newBalance,
          });
          dispatch(
            loadAccountTransactionList({
              organizationId: organizationId,
              accountId: selectedBankAccount._id,
            })
          );
          dispatch(
            loadCashBankList({
              organizationId: organizationId,
            })
          );
          dispatch(
            loadCashBankTotalList({
              organizationId: organizationId,
            })
          );
          setValidations(false);

          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(errorMsg || `An Error occured while adding the bank`);
          Promise.reject(error);
        });
    } else if (!isEmpty(addMoneyIn) && adjustBalanceData.adjustAmount) {
      const bankDetails = {
        isAdd: adjustMode === "Add" ? true : false,
        isReduce: adjustMode === "Reduce" ? true : false,
        enterPaymentAmount: parseInt(adjustBalanceData.adjustAmount),
        // if  bank account select means add  accountId
        accountId:
          addMoneyIn === "66c9bd5ab3fca462ca48a87e"
            ? ""
            : accountDetails.length == 0
            ? ""
            : accountId
            ? accountId
            : accountDetails,

        paymentDate: adjustDate ? moment(adjustDate).format("YYYY-MM-DD") : "",
        createdBy: createdById,
        paymentModeId: adjustBalanceData.paymentModeId
          ? adjustBalanceData.paymentModeId
          : addMoneyIn,
        organizationId: organizationId,
      };
      setIsButtonDisabled(true);

      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 3000);
      const bankDetailsObj = Object.keys(bankDetails).forEach(
        (key) =>
          (bankDetails[key] === "" || bankDetails[key] === undefined) &&
          delete bankDetails[key]
      );
      console.log(bankDetailsObj, "bankDetailsObj");
      api
        .post("/org/addorreducemoney", bankDetails)
        .then((res) => {
          setAddMoneyModal(false);
          toast.success("Money Values adjusted succesfully");
          setAdjustBalanceData({
            currentBalance: newBalance,
          });
          dispatch(
            loadAccountTransactionList({
              organizationId: organizationId,
              accountId: selectedBankAccount._id,
            })
          );
          dispatch(
            loadCashBankList({
              organizationId: organizationId,
            })
          );
          dispatch(
            loadCashBankTotalList({
              organizationId: organizationId,
            })
          );
          setValidations(false);

          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(errorMsg || `An Error occured while adding the bank`);
          Promise.reject(error);
        });
    } else {
      setValidations(true);
    }
  };

  const today = moment().format("YYYY-MM-DD");
  const [asOfDate, setAsOfDate] = useState("");
  const [bankDetailsChecked, setBankDetailsChecked] = useState(false);

  console.log(asOfDate, "asOfDate");
  useEffect(() => {
    // setAddMoneyIn({ label: "Cash", value: "Cash" });
    setAsOfDate(today);
    setAdjustDate(today);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //download statement
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [downloadCashInHand, setDownloadCashInHand] = useState(false);
  const [downloadTotalTransaction, setDownloadTotalTransaction] =
    useState(false);
  // const handleDownloadPDF = () => {

  //   const input = document.getElementById("pdf-content");
  //   // Specify the id of the element you want to convert to PDF
  //   // setDownloadLoading(true);

  //   setDownloadLoading(true);
  //   setTimeout(() => {
  //     setDownloadLoading(false);
  //   }, 3000);

  //   setTimeout(() => {
  //     html2canvas(input).then((canvas) => {
  //       const imgData = canvas.toDataURL("image/png");
  //       const pdf = new jsPDF();
  //       pdf.addImage(imgData, "PNG", 1, 10);
  //       pdf.save("bank-transaction.pdf");
  //       // setDownloadLoading(false);
  //       // Specify the name of the downloaded PDF file
  //     });
  //   }, 1200);
  // };
  const handleDownloadPDF = async () => {
    const pdf = new jsPDF();
    const firstPageRows = 32; // Rows for the first page
    const subsequentPageRows = 32; // Rows for subsequent pages
    const tableChunks = [];
    setDownloadLoading(true);
    setTimeout(() => {
      setDownloadLoading(false);
    }, 3000);
    // Split data into chunks of 50 rows
    tableChunks.push(transactionRows.slice(0, firstPageRows));
    for (
      let i = firstPageRows;
      i < transactionRows.length;
      i += subsequentPageRows
    ) {
      tableChunks.push(transactionRows.slice(i, i + subsequentPageRows));
    }

    for (let i = 0; i < tableChunks.length; i++) {
      // Create a temporary table for each chunk
      const tempDiv = document.createElement("div");
      tempDiv.style.width = "1000px"; // Ensure consistent width for rendering
      tempDiv.innerHTML = `
        <table style="width: 100%; border-collapse: collapse;, margin-top: -40px;">
          <thead>
            <tr>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins;">S.No</th>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins">Payment Date</th>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins">Payment No</th>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins">Amount</th>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins">Received Amount</th>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins">Balance Amount</th>
            </tr>
          </thead>
          <tbody>
            ${tableChunks[i]
              .map(
                (row, index) => `
              <tr>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  index +
                  1 +
                  (i === 0 ? 0 : firstPageRows + (i - 1) * subsequentPageRows)
                }</td>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  row.paymentDate
                    ? moment(row.paymentDate).format("DD-MM-YYYY")
                    : ""
                }</td>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  prefix_settings_list &&
                  !isEmpty(prefix_settings_list.prefixName) &&
                  row.paymentNo
                    ? prefix_settings_list.prefixName + " " + row.paymentNo
                    : row.paymentNo !== null
                    ? row.paymentNo
                    : ""
                }</td>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  row.paidAmount
                }</td>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  row.receivedAmount
                }</td>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  row.balanceAmount
                }</td>
              </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
      `;

      document.body.appendChild(tempDiv);

      // Render table as an image
      const canvas = await html2canvas(tempDiv, { scale: 1.5 }); // Lower scale for smaller size
      const imgData = canvas.toDataURL("image/jpeg", 0.7); // Use JPEG with quality of 0.7
      const imgWidth = 190; // PDF width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (i > 0) pdf.addPage();
      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);

      // Add page number
      const pageNumber = i + 1;
      pdf.setFontSize(10); // Set font size for page number
      pdf.text(
        `Page ${pageNumber}`,
        pdf.internal.pageSize.getWidth() - 160,
        pdf.internal.pageSize.getHeight() - 10
      ); // Bottom-right corner

      document.body.removeChild(tempDiv);
    }

    pdf.save("Bank-statement.pdf");
  };

  const handleDownloadCashInHand = async () => {
    const pdf = new jsPDF();
    const firstPageRows = 32; // Rows for the first page
    const subsequentPageRows = 32; // Rows for subsequent pages
    const tableChunks = [];
    setDownloadCashInHand(true);
    setTimeout(() => {
      setDownloadCashInHand(false);
    }, 3000);
    // Split data into chunks of 50 rows
    tableChunks.push(totalCashTransactionRows.slice(0, firstPageRows));
    for (
      let i = firstPageRows;
      i < totalCashTransactionRows.length;
      i += subsequentPageRows
    ) {
      tableChunks.push(
        totalCashTransactionRows.slice(i, i + subsequentPageRows)
      );
    }

    for (let i = 0; i < tableChunks.length; i++) {
      // Create a temporary table for each chunk
      const tempDiv = document.createElement("div");
      tempDiv.style.width = "1000px"; // Ensure consistent width for rendering
      tempDiv.innerHTML = `
        <table style="width: 100%; border-collapse: collapse;, margin-top: -40px;">
          <thead>
            <tr>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins;">S.No</th>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins">Payment Date</th>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins">Payment No</th>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins">Amount</th>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins">Received Amount</th>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins">Balance Amount</th>
            </tr>
          </thead>
          <tbody>
            ${tableChunks[i]
              .map(
                (row, index) => `
              <tr>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  index +
                  1 +
                  (i === 0 ? 0 : firstPageRows + (i - 1) * subsequentPageRows)
                }</td>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  row.paymentDate
                    ? moment(row.paymentDate).format("DD-MM-YYYY")
                    : ""
                }</td>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  prefix_settings_list &&
                  !isEmpty(prefix_settings_list.prefixName) &&
                  row.paymentNo
                    ? prefix_settings_list.prefixName + " " + row.paymentNo
                    : row.paymentNo !== null
                    ? row.paymentNo
                    : ""
                }</td>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  row.paidAmount
                }</td>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  row.receivedAmount
                }</td>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  row.balanceAmount
                }</td>
              </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
      `;

      document.body.appendChild(tempDiv);

      // Render table as an image
      const canvas = await html2canvas(tempDiv, { scale: 1.5 }); // Lower scale for smaller size
      const imgData = canvas.toDataURL("image/jpeg", 0.7); // Use JPEG with quality of 0.7
      const imgWidth = 190; // PDF width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (i > 0) pdf.addPage();
      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);

      // Add page number
      const pageNumber = i + 1;
      pdf.setFontSize(10); // Set font size for page number
      pdf.text(
        `Page ${pageNumber}`,
        pdf.internal.pageSize.getWidth() - 160,
        pdf.internal.pageSize.getHeight() - 10
      ); // Bottom-right corner

      document.body.removeChild(tempDiv);
    }

    pdf.save("Cash in hand.pdf");
  };

  const handleDownloadTotalTransaction = async () => {
    const pdf = new jsPDF();
    const firstPageRows = 32; // Rows for the first page
    const subsequentPageRows = 32; // Rows for subsequent pages
    const tableChunks = [];
    setDownloadTotalTransaction(true);
    setTimeout(() => {
      setDownloadTotalTransaction(false);
    }, 3000);
    // Split data into chunks of 50 rows
    tableChunks.push(totalTransactionRows.slice(0, firstPageRows));
    for (
      let i = firstPageRows;
      i < totalTransactionRows.length;
      i += subsequentPageRows
    ) {
      tableChunks.push(totalTransactionRows.slice(i, i + subsequentPageRows));
    }

    for (let i = 0; i < tableChunks.length; i++) {
      // Create a temporary table for each chunk
      const tempDiv = document.createElement("div");
      tempDiv.style.width = "1000px"; // Ensure consistent width for rendering
      tempDiv.innerHTML = `
        <table style="width: 100%; border-collapse: collapse;, margin-top: -40px;">
          <thead>
            <tr>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins;">S.No</th>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins">Payment Date</th>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins">Payment No</th>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins">Amount</th>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins">Received Amount</th>
              <th style="border: 1px solid #000; padding: 8px; font-family: Poppins">Balance Amount</th>
            </tr>
          </thead>
          <tbody>
            ${tableChunks[i]
              .map(
                (row, index) => `
              <tr>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  index +
                  1 +
                  (i === 0 ? 0 : firstPageRows + (i - 1) * subsequentPageRows)
                }</td>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  row.paymentDate
                    ? moment(row.paymentDate).format("DD-MM-YYYY")
                    : ""
                }</td>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  prefix_settings_list &&
                  !isEmpty(prefix_settings_list.prefixName) &&
                  row.paymentNo
                    ? prefix_settings_list.prefixName + " " + row.paymentNo
                    : row.paymentNo !== null
                    ? row.paymentNo
                    : ""
                }</td>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  row.paidAmount
                }</td>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  row.receivedAmount
                }</td>
                <td style="border: 1px solid #000; padding: 8px; font-family: Poppins; text-align: center;">${
                  row.balanceAmount
                }</td>
              </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
      `;

      document.body.appendChild(tempDiv);

      // Render table as an image
      const canvas = await html2canvas(tempDiv, { scale: 1.5 }); // Lower scale for smaller size
      const imgData = canvas.toDataURL("image/jpeg", 0.7); // Use JPEG with quality of 0.7
      const imgWidth = 190; // PDF width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (i > 0) pdf.addPage();
      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);

      // Add page number
      const pageNumber = i + 1;
      pdf.setFontSize(10); // Set font size for page number
      pdf.text(
        `Page ${pageNumber}`,
        pdf.internal.pageSize.getWidth() - 160,
        pdf.internal.pageSize.getHeight() - 10
      ); // Bottom-right corner

      document.body.removeChild(tempDiv);
    }

    pdf.save("Total-transactions.pdf");
  };

  // const handleDownloadTotalTransaction = () => {
  //   const input = document.getElementById("cash-total-transaction");
  //   // Specify the id of the element you want to convert to PDF
  //   // setDownloadLoading(true);

  //   setDownloadTotalTransaction(true);
  //   setTimeout(() => {
  //     setDownloadTotalTransaction(false);
  //   }, 3000);

  //   setTimeout(() => {
  //     html2canvas(input).then((canvas) => {
  //       const imgData = canvas.toDataURL("image/png");
  //       const pdf = new jsPDF();
  //       pdf.addImage(imgData, "PNG", 1, 10);
  //       pdf.save("cash-in-hand.pdf");
  //       // setDownloadLoading(false);
  //       // Specify the name of the downloaded PDF file
  //     });
  //   }, 1200);
  // };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //copy paste
  const handleCopy = async (data) => {
    // if (selectedText) {
    try {
      await navigator.clipboard.writeText(data); // Copy to clipboard
      setCopiedText(data); // Update the copied text state
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
    // }
  };

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Cash Bank | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        {/* <Skeleton.Input
          style={{
            padding: "5px",
            width: "100%",
          }}
          active={true}
          size={"large"}
        > */}
        <Col span={24} className="border border-b-1 border-x-0 border-t-0">
          <div
            className={
              media === "xxl" ||
              media === "xl" ||
              media === "md" ||
              media === "lg"
                ? "font-poppins flex justify-between pl-[20px] pr-[20px] mt-4 pb-2"
                : "font-poppins flex flex-col pl-[20px] pr-[20px] mt-4 pb-2"
            }
          >
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[18px] ml-1 pb-2 font-semibold"
              >
                Cash and Bank
              </h1>
            </div>
            <div
              className={
                media === "xxl" ||
                media === "xl" ||
                media === "md" ||
                media === "lg"
                  ? "flex"
                  : media === "xs"
                  ? "flex flex-col mt-2"
                  : "flex mt-2"
              }
            >
              <Tooltip
                title="Add & Reduce money"
                placement="left"
                rootClassName="text-[10px]"
              >
                <div
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                  }}
                  onClick={() => {
                    setAddMoneyModal(true);
                    setAdjustBalanceData({
                      ...adjustBalanceData,
                      adjustRemarks: "",
                      adjustAmount: "",
                      paymentModeId: "66c9bd5ab3fca462ca48a87e",
                    });
                    setAccountDetails(selectedBankAccount.accountName);
                    // setAddMoneyIn("Cash");
                    setAccountId(selectedBankAccount._id);
                    setAdjustMode("Add");
                    // setAddMoneyIn(selectedBankAccount.paymentModeName);
                    dispatch(loadPaymentInListRecordsMetaData());
                  }}
                  className={
                    // isEmpty(selectedBankAccount.accountHolderName)
                    //   ? "pointer-events-none bg-[lightgray] opacity-1 border border-1 rounded-md flex w-[190px] pl-5 pr-5 pt-2 pb-1 cursor-pointer"
                    //   :
                    "border border-1 rounded-md flex w-[190px] pl-5 pr-5 pt-2 pb-1 cursor-pointer"
                  }
                >
                  <div className="mt-[-3px] mr-2">
                    <p className="font-bold cash-label mb-[-6px] text-[13px]">
                      +
                    </p>
                    <p className="font-bold cash-label mt-[-12px] text-[13px]">
                      -
                    </p>
                  </div>{" "}
                  Add Reduce Money
                </div>
              </Tooltip>
              <div
                onClick={() => {
                  setUpdateBankModal(true);
                  setBankMode("Add");
                  setBankData({
                    accountName: "",
                    openingBalance: "",
                    accountNumber: "",
                    reAccountNumber: "",
                    ifscCode: "",
                    bankName: "",
                    bankBranchName: "",
                    accountHoldersName: "",
                    upiId: "",
                    _id: "",
                  });
                  // setAsOfDate("");
                }}
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
                className={
                  media === "xs"
                    ? "mt-2 w-[190px] border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md pl-8 pr-8 p-1.5 cursor-pointer"
                    : "w-[190px] border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-3 pl-8 pr-8 p-1.5 cursor-pointer"
                }
              >
                + Add New Account
              </div>
            </div>
          </div>
        </Col>
        <Col span={24} className="pb-3">
          <Row
            className={
              media === "sm" || media === "xs"
                ? "transaction-cash-bank-card-mobile-main"
                : ""
            }
          >
            {/* Account list */}
            <Col
              md={7}
              sm={24}
              lg={7}
              xs={24}
              className={
                media === "sm" || media === "xs"
                  ? ""
                  : "border border-r-1 border-y-0 border-l-0"
              }
            >
              <Row>
                <Col span={24} className="p-5">
                  <div className="flex justify-between">
                    <h1
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="text-[black] text-[14px]"
                    >
                      Total Balance:
                    </h1>
                    <p className="text-[black] flex font-semibold text-[14px]">
                      ₹
                      <p
                        style={{
                          fontFamily: "Poppins",
                          marginLeft: "4px",
                        }}
                      >
                        {cash_bank_total && cash_bank_total.totalBalance
                          ? cash_bank_total.totalBalance.toLocaleString("en-IN")
                          : 0}
                      </p>
                    </p>
                  </div>
                </Col>
                <Col span={24}>
                  <Row className="w-[100%] bg-gray-50 p-1 border border-x-0 pl-5 pr-5">
                    <h1
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="text-[16px] text-[#084d7b] font-semibold"
                    >
                      {" "}
                      Cash
                    </h1>
                  </Row>
                </Col>
                <Col
                  span={24}
                  onClick={() => {
                    setSelectedTransaction("Cash in hand");
                    setSelectedOption("Select Option");
                    dispatch(
                      loadCashInHandTransaction({
                        organizationId: organizationId,
                      })
                    );
                    setAddMoneyIn("Cash");
                    setAdjustBalanceData({
                      ...adjustBalanceData,
                      paymentModeId: "66c9bd5ab3fca462ca48a87e",
                    });
                    setAdjustMode("Add");
                    setSelectedCashInLoad(true);
                    setTimeout(() => {
                      setSelectedCashInLoad(false);
                    }, 1000);
                  }}
                  className={
                    selectedTransaction === "Cash in hand"
                      ? "cursor-pointer bg-[#eeecfb]"
                      : "cursor-pointer hover:bg-[#eeecfb]"
                  }
                >
                  <div className="flex justify-between p-5">
                    <h1
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="text-[black] text-[14px]"
                    >
                      Cash in hand
                    </h1>
                    <p className="text-[black] flex font-semibold text-[14px]">
                      ₹
                      <p
                        style={{
                          fontFamily: "Poppins",
                          marginLeft: "4px",
                        }}
                      >
                        {cash_hand_list && cash_hand_list.cashInHand
                          ? cash_hand_list.cashInHand.toLocaleString("en-IN")
                          : 0}
                      </p>
                    </p>
                  </div>
                </Col>
                <Col span={24}>
                  <Row className="w-[100%] bg-gray-50 p-1 border border-x-0 pl-5 pr-5">
                    <h1
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                      }}
                      className="text-[16px] text-[#084d7b] font-semibold"
                    >
                      {" "}
                      Bank Accounts
                    </h1>
                  </Row>
                </Col>
                <Col
                  span={24}
                  className={
                    windowDimensions.height > 600 &&
                    windowDimensions.height < 650
                      ? "bank-account-details-card-small"
                      : windowDimensions.height > 650 &&
                        windowDimensions.height < 700
                      ? "bank-account-details-card-medium"
                      : windowDimensions.height > 700 &&
                        windowDimensions.height < 830
                      ? "bank-account-details-card-large-device"
                      : windowDimensions.height > 830 &&
                        windowDimensions.height < 900
                      ? "bank-account-details-card-extra-large-device"
                      : windowDimensions.height > 900 &&
                        windowDimensions.height < 1000
                      ? "bank-account-details-card-extra-extra-large-device"
                      : windowDimensions.height > 1000
                      ? "bank-account-details-card-extra-infinite-device"
                      : "bank-account-details-card"
                  }
                >
                  <Row>
                    <Col
                      span={24}
                      onClick={() => {
                        setSelectedTransaction("Unlinked Transactions");
                        setSelectedOption("Select Option");
                        setAdjustMode("Add");
                      }}
                      className={
                        selectedTransaction === "Unlinked Transactions"
                          ? "cursor-pointer border bg-[#eeecfb] border-b-1 border-x-0 border-t-0"
                          : "cursor-pointer border hover:bg-[#eeecfb] border-b-1 border-x-0 border-t-0"
                      }
                    >
                      <div className="flex justify-between p-5">
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="cash-label text-[black] text-[14px]"
                        >
                          <BankOutlined className="text-[14px] mr-3" /> Unlinked
                          Transactions
                        </h1>
                        <p className="text-[black] flex font-semibold text-[14px]">
                          ₹
                          <p
                            style={{
                              fontFamily: "Poppins",
                              marginLeft: "4px",
                            }}
                          >
                            0
                          </p>
                        </p>
                      </div>
                    </Col>
                    {cash_bank_details && cash_bank_details.length > 0 ? (
                      cash_bank_details.map((data) => {
                        return (
                          <Col
                            span={24}
                            onClick={() => {
                              setSelectedBankAccount({
                                _id: data._id,
                                accountName: data.accountName,
                                accountHolderName: data.accountHolderName,
                                accountNumber: data.accountNumber,
                                ifscCode: data.ifscCode,
                                bankName: data.bankName,
                                bankBranch: data.bankBranch,
                                upiId: data.upiId,
                                openingBalance: data.openingBalance,
                                currentBalance: data.currentBalance,
                                paymentModeName: data.paymentModeName,
                                paymentModeId: data.paymentModeId,
                              });
                              const date = data.asOfDate
                                ? moment(data.asOfDate).format("YYYY-MM-DD")
                                : "";
                              setAsOfDate(date);

                              setAdjustBalanceData({
                                ...adjustBalanceData,
                                currentBalance: data.currentBalance,
                                paymentModeId: "66c9bd7bb3fca462ca48a882",
                              });
                              dispatch(
                                loadAccountTransactionList({
                                  organizationId: organizationId,
                                  accountId: data._id,
                                })
                              );
                              dispatch(
                                loadPartyAccountList({
                                  organizationId: organizationId,
                                })
                              );
                              setAdjustMode("Add");
                              setAddMoneyIn("Bank");
                              setSelectedTransaction("Savings");
                              setSelectedOption("Select Option");
                              setSelectedBankLoad(true);
                              setTimeout(() => {
                                setSelectedBankLoad(false);
                              }, 1000);
                            }}
                            className={
                              selectedTransaction === "Savings" &&
                              data._id === selectedBankAccount._id
                                ? "cursor-pointer border bg-[#eeecfb] border-b-1 border-x-0 border-t-0"
                                : "cursor-pointer border hover:bg-[#eeecfb] border-b-1 border-x-0 border-t-0"
                            }
                          >
                            <div className="flex justify-between p-4">
                              <div className="flex">
                                <BankOutlined className="text-[20px]" />
                                <div className="ml-2">
                                  <h1 className="cash-label text-[black] text-[14px]">
                                    {data.accountName && data.accountName}
                                  </h1>
                                  <p>
                                    {data.accountNumber && data.accountNumber}
                                  </p>
                                </div>
                              </div>

                              <p className="text-[black] flex font-semibold text-[14px]">
                                ₹
                                <p
                                  style={{
                                    fontFamily: "Poppins",
                                    marginLeft: "4px",
                                  }}
                                >
                                  {data.currentBalance &&
                                    data.currentBalance.toLocaleString("en-IN")}
                                </p>
                              </p>
                            </div>
                          </Col>
                        );
                      })
                    ) : (
                      <p
                        style={{
                          fontFamily: "Poppins",
                          textAlign: "center",
                          width: "100%",
                          marginTop: "6px",
                        }}
                      >
                        No bank accounts found...
                      </p>
                    )}
                  </Row>
                </Col>
                <Col span={24} className="p-2">
                  <div
                    onClick={() => {
                      setUpdateBankModal(true);
                      setBankMode("Add");
                      setBankData({
                        accountName: "",
                        openingBalance: "",
                        currentBalance: "",
                        accountNumber: "",
                        reAccountNumber: "",
                        ifscCode: "",
                        bankName: "",
                        bankBranchName: "",
                        accountHoldersName: "",
                        upiId: "",
                      });
                      setAsOfDate("");
                    }}
                    className="cursor-pointer ml-2 text-[#488dff] text-[13px] items-label p-2"
                  >
                    + Add New Bank
                  </div>
                </Col>
              </Row>
            </Col>

            {/* Transation section cards */}

            <Col md={17} sm={24} lg={17} xs={24}>
              <Row>
                <Col
                  span={24}
                  className={
                    media === "sm" || media === "xs"
                      ? ""
                      : "border border-r-1 border-y-0 border-l-0"
                  }
                >
                  <Row>
                    <Col
                      md={24}
                      sm={24}
                      lg={24}
                      xs={24}
                      className="border border-y-0 border-r-1 border-l-0 bg-[#eeecfb] p-3"
                    >
                      <div className="">
                        <h1 className="text-[#4c3cce] font-semibold text-[16px]">
                          Transactions
                        </h1>
                      </div>
                    </Col>
                  </Row>
                </Col>
                {/* bank account all details */}
                <Col
                  span={24}
                  // onMouseEnter={() => setOnMouseEnter(true)}
                  // onMouseLeave={() => setOnMouseEnter(false)}

                  className={
                    media === "sm" || media === "xs"
                      ? ""
                      : windowDimensions.height > 600 &&
                        windowDimensions.height < 650
                      ? "cash-bank-details-card-mobile"
                      : windowDimensions.height > 650 &&
                        windowDimensions.height < 700
                      ? "transaction-cash-bank-card-medium"
                      : windowDimensions.height > 700 &&
                        windowDimensions.height < 830
                      ? "transaction-cash-bank-card-large-device mt-3"
                      : windowDimensions.height > 830 &&
                        windowDimensions.height < 900
                      ? "transaction-cash-bank-card-extra-large-device mt-3"
                      : windowDimensions.height > 900 &&
                        windowDimensions.height < 1000
                      ? "transaction-cash-bank-card-extra-extra-large-device mt-3"
                      : windowDimensions.height > 1000
                      ? "transaction-cash-bank-card-extra-infinite-device mt-3"
                      : "transaction-cash-bank-card mt-3"
                  }
                  id="pdf-content"
                  // selectedTransaction === "Savings" &&
                  // (media === "lg" ||
                  //   media === "md" ||
                  //   media === "xl" ||
                  //   media === "xxl")
                  //   ? // selectedTransaction === "Savings" && onMouseEnter
                  //     "items-main-card"
                  //   : ""
                >
                  <Row>
                    {selectedTransaction === "Savings" && (
                      <Col md={24} sm={24} lg={24} xs={24}>
                        <Row
                          className={
                            media === "lg" ||
                            media === "md" ||
                            media === "xl" ||
                            media === "xxl"
                              ? "border border-b-1 pl-3 border-x-0 border-t-0 flex justify-between"
                              : "border border-b-1 border-x-0 border-t-0 flex flex-col"
                          }
                        >
                          <Col md={10} sm={24} lg={10} xs={24} className="p-3">
                            <div className="mt-2 ">
                              <h1
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                className="flex font-medium text-[#021c2efd] text-[13px] mb-1"
                              >
                                Account Holder's Name:{" "}
                                <p className=" text-[12px] font-semibold ml-2">
                                  {" "}
                                  {selectedBankAccount &&
                                  selectedBankAccount.accountHolderName
                                    ? selectedBankAccount.accountHolderName
                                    : ""}
                                </p>
                              </h1>
                              <h1
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                className="flex font-medium text-[#021c2efd] text-[13px] mb-1"
                              >
                                Account Name:
                                <p className=" text-[12px] font-semibold ml-2">
                                  {selectedBankAccount &&
                                  selectedBankAccount.accountName
                                    ? selectedBankAccount.accountName
                                    : ""}
                                </p>
                              </h1>
                              <h1
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                className="flex font-medium text-[#021c2efd] text-[15px] mb-1"
                              >
                                Account Number:
                                <p className=" text-[14px] font-semibold ml-2">
                                  {selectedBankAccount &&
                                  selectedBankAccount.accountNumber
                                    ? selectedBankAccount.accountNumber
                                    : ""}
                                </p>
                              </h1>
                              <h1
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                className="flex font-medium text-[#021c2efd] text-[13px] mb-1"
                              >
                                IFSC Code:
                                <p className=" font-semibold text-[12px] ml-2">
                                  {selectedBankAccount &&
                                  selectedBankAccount.ifscCode
                                    ? selectedBankAccount.ifscCode
                                    : ""}
                                </p>
                              </h1>
                              <h1
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                className="flex font-medium text-[#021c2efd] text-[13px] mb-1"
                              >
                                Bank & Branch:
                                <p className=" text-[12px] font-semibold ml-2">
                                  {" "}
                                  {!isEmpty(selectedBankAccount.bankName) &&
                                  !isEmpty(selectedBankAccount.bankBranch)
                                    ? `${
                                        selectedBankAccount.bankName +
                                        " & " +
                                        selectedBankAccount.bankBranch
                                      }`
                                    : ""}
                                </p>
                              </h1>
                            </div>
                          </Col>
                          {/* {downloadLoading ? (
                            ""
                          ) : ( */}
                          <Col
                            className={
                              media === "lg" ||
                              media === "md" ||
                              media === "xl" ||
                              media === "xxl"
                                ? "p-3"
                                : "mb-[-60px]"
                            }
                          >
                            <div
                              onClick={() => {
                                setAddBankModal(true);
                              }}
                              className={
                                media === "lg" ||
                                media === "md" ||
                                media === "xl" ||
                                media === "xxl"
                                  ? "text-[12px] flex justify-between border mb-2 rounded-md p-2 cursor-pointer"
                                  : "text-[12px] w-[50%] flex ml-2 justify-between border mb-2 rounded-md p-2 cursor-pointer"
                              }
                            >
                              Update Bank Details{" "}
                              <EditOutlined className="text-[16px] ml-3" />
                            </div>
                            <div
                              onClick={() => setShareAccountModal(true)}
                              className={
                                media === "lg" ||
                                media === "md" ||
                                media === "xl" ||
                                media === "xxl"
                                  ? "text-[12px] flex justify-between border mb-2 rounded-md p-2 cursor-pointer"
                                  : "text-[12px] w-[50%] flex ml-2 justify-between border mb-2 rounded-md p-2 cursor-pointer"
                              }
                            >
                              Share Bank Details{" "}
                              <ShareAltOutlined className="text-[16px]" />
                            </div>
                            <div>
                              <div
                                className={
                                  media === "lg" ||
                                  media === "md" ||
                                  media === "xl" ||
                                  media === "xxl"
                                    ? "text-[12px] border mb-2 rounded-md p-2 cursor-pointer"
                                    : "text-[12px] w-[50%] ml-2 border mb-2 rounded-md p-2 cursor-pointer"
                                }
                                onClick={handleDownloadPDF}
                              >
                                {downloadLoading ? (
                                  <p className="flex">
                                    <Spin className="mr-2" /> Downloading
                                  </p>
                                ) : (
                                  <div className="flex justify-between">
                                    Download Statement{" "}
                                    <BiDownload size={16} className="ml-3" />
                                  </div>
                                )}
                              </div>
                            </div>
                          </Col>
                          {/* )} */}
                        </Row>
                      </Col>
                    )}
                    {/* {downloadLoading ? (
                      ""
                    ) : ( */}
                    <Col span={24}>
                      <Row className="flex justify-between p-3">
                        <Col span={6}>
                          <div className="relative w-auto">
                            <select
                              className="filter-span w-[200px] p-2 border-1 rounded"
                              value={selectedOption}
                              onChange={handleOptionSelect}
                              style={{
                                fontFamily: "Poppins",
                              }}
                            >
                              {options.map((option) => (
                                <option
                                  key={option}
                                  value={option}
                                  className="mr-2"
                                >
                                  {option}
                                </option>
                              ))}
                            </select>
                          </div>
                          {/* Modal */}
                          {isModalOpen && (
                            <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
                              <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                                <h2
                                  className="text-lg font-bold mb-4"
                                  style={{
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  Select Date Range
                                </h2>
                                <div className="space-y-4">
                                  <div className="flex flex-col">
                                    <label
                                      htmlFor="from-date"
                                      className="expense-label text-sm mb-1"
                                    >
                                      From
                                    </label>
                                    <DatePicker
                                      selected={fromDate}
                                      className={
                                        media == "sm"
                                          ? "rounded-md border border-1 h-[40px] w-[95%] mt-1 mb-2 pl-2"
                                          : media == "xs"
                                          ? "rounded-md border border-1 h-[40px] w-[95%] mt-1 mb-2 pl-2"
                                          : media == "xl" ||
                                            media == "xxl" ||
                                            media == "lg"
                                          ? "rounded-md border border-1 h-[40px] w-[95%] mt-1 mb-2 pl-2"
                                          : "rounded-md border border-1 h-[40px] w-[95%] pl-2"
                                      }
                                      toggleCalendarOnIconClick={true}
                                      icon={
                                        <BiCalendar
                                          //   size={30}

                                          className={
                                            media == "sm"
                                              ? "top-[5px] text-[16px] right-[20px] text-[#9e9e9e]"
                                              : media == "xs"
                                              ? "top-[5px] text-[16px] right-[20px] text-[#9e9e9e]"
                                              : media == "xl" ||
                                                media == "xxl" ||
                                                media == "lg"
                                              ? "top-[7px] text-[16px] right-[20px] text-[#9e9e9e]"
                                              : "top-[3px] text-[16px] right-[20px] text-[#9e9e9e]"
                                          }
                                        />
                                      }
                                      showIcon
                                      onChange={(date) => {
                                        setFromDate(date);
                                      }}
                                      placeholderText="Select Date"
                                    />
                                    {/* <input
                                        id="from-date"
                                        type="date"
                                        className="expense-label border p-2 rounded w-full"
                                        onChange={(e) =>
                                          setFromDate(e.target.value)
                                        }
                                      /> */}
                                  </div>
                                  <div className="flex flex-col">
                                    <label
                                      htmlFor="to-date"
                                      className="text-sm mb-1 expense-label"
                                      style={{
                                        fontFamily: "Poppins",
                                      }}
                                    >
                                      To
                                    </label>
                                    <DatePicker
                                      selected={toDate}
                                      className={
                                        media == "sm"
                                          ? "rounded-md border border-1 h-[40px] w-[95%] mt-1 mb-2 pl-2"
                                          : media == "xs"
                                          ? "rounded-md border border-1 h-[40px] w-[95%] mt-1 mb-2 pl-2"
                                          : media == "xl" ||
                                            media == "xxl" ||
                                            media == "lg"
                                          ? "rounded-md border border-1 h-[40px] w-[95%] mt-1 mb-2 pl-2"
                                          : "rounded-md border border-1 h-[40px] w-[95%] pl-2"
                                      }
                                      toggleCalendarOnIconClick={true}
                                      icon={
                                        <BiCalendar
                                          //   size={30}

                                          className={
                                            media == "sm"
                                              ? "top-[5px] text-[16px] right-[20px] text-[#9e9e9e]"
                                              : media == "xs"
                                              ? "top-[5px] text-[16px] right-[20px] text-[#9e9e9e]"
                                              : media == "xl" ||
                                                media == "xxl" ||
                                                media == "lg"
                                              ? "top-[7px] text-[16px] right-[20px] text-[#9e9e9e]"
                                              : "top-[3px] text-[16px] right-[20px] text-[#9e9e9e]"
                                          }
                                        />
                                      }
                                      showIcon
                                      onChange={(date) => {
                                        setToDate(date);
                                      }}
                                      placeholderText="Select Date"
                                    />
                                    {/* <input
                                        id="to-date"
                                        type="date"
                                        
                                        className="border p-2 rounded expense-label w-full"
                                        onChange={(e) =>
                                          setToDate(e.target.value)
                                        }
                                      /> */}
                                  </div>
                                </div>
                                <div className="flex justify-center mt-6 space-x-2">
                                  <button
                                    className="px-2 py-2 expense-label rounded bg-gray-200 hover:bg-gray-300"
                                    onClick={() => setIsModalOpen(false)}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    className="py-2 px-2 expense-label rounded bg-[blue] text-white hover:bg-blue-300"
                                    onClick={handleApply}
                                    // disabled={
                                    //   isEmpty(fromDate) || isEmpty(toDate)
                                    // }
                                  >
                                    Apply
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                          {/* <Select
                              suffixIcon={<BiCalendar size={16} />}
                              placeholder="Select Calendar"
                              //   value={selectDays}
                              //   onChange={(e) => setSelectDays(e)}
                              className="h-[40px] w-[100%]"
                            /> */}
                        </Col>

                        <Col>
                          {selectedTransaction === "Savings" ? (
                            ""
                          ) : selectedTransaction === "Cash in hand" ? (
                            <div
                              onClick={handleDownloadCashInHand}
                              className="flex border rounded-md p-2 cursor-pointer"
                            >
                              {downloadCashInHand ? (
                                <p className="flex">
                                  <Spin /> Downloading
                                </p>
                              ) : (
                                <div className="flex">
                                  Download Statement{" "}
                                  <BiDownload size={16} className="ml-3" />
                                </div>
                              )}
                            </div>
                          ) : (
                            <div
                              onClick={handleDownloadTotalTransaction}
                              className="border rounded-md p-2 cursor-pointer"
                            >
                              {downloadTotalTransaction ? (
                                <p className="flex">
                                  <Spin />
                                </p>
                              ) : (
                                <div className="flex">
                                  <BiDownload size={16} className="ml-3" />
                                </div>
                              )}
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Col>
                    {/* )} */}

                    {selectedTransaction === "Cash in hand" ? (
                      <Col id="cash-in-pdf" span={24} className="p-2">
                        <Row>
                          {totalCashTransactionRows &&
                          totalCashTransactionRows.length > 0 ? (
                            <Col
                              // md={24}
                              // sm={24}
                              // xl={24}
                              // xxl={24}
                              // lg={24}
                              span={24}
                              className="w-[100%] p-4 overflow overflow-auto"
                            >
                              <table className="w-[100%] overflow overflow-y-hidden overflow-x-auto mb-[5rem] table-cash-bank table-responsive">
                                <thead>
                                  <tr className="table-cash-bank-head-main">
                                    <th className="w-[5%] uppercase table-cash-bank-head text-[12px] font-semibold">
                                      S.No
                                    </th>
                                    <th className="w-[20%] uppercase table-cash-bank-head text-[12px] font-semibold">
                                      Payment Date
                                    </th>
                                    <th className="w-[20%] uppercase table-cash-bank-head text-[12px] font-semibold">
                                      Payment No
                                    </th>
                                    <th className="w-[15%] uppercase table-cash-bank-head text-[12px] font-semibold">
                                      Amount
                                    </th>
                                    <th className="w-[20%] uppercase table-cash-bank-head text-[12px] font-semibold">
                                      Received Amount
                                    </th>
                                    <th className="w-[20%] uppercase text-end table-cash-bank-head text-[12px] font-semibold">
                                      Balance Amount
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="mb-8">
                                  {totalCashTransactionRows &&
                                  totalCashTransactionRows.length > 0 &&
                                  !selectedCashInLoad
                                    ? totalCashTransactionRows.map(
                                        (data, index) => {
                                          return (
                                            <tr
                                              key={index}
                                              className={
                                                "table-cash-bank-row border border-b-1 border-x-0 border-t-0"
                                              }
                                            >
                                              <td
                                                className={
                                                  "table-cash-bank-data p-2"
                                                }
                                              >
                                                {index + 1}
                                              </td>
                                              <td
                                                className={
                                                  "table-cash-bank-data p-2"
                                                }
                                              >
                                                <p
                                                  style={{
                                                    fontFamily: "Poppins",
                                                  }}
                                                >
                                                  {" "}
                                                  {data.paymentDate
                                                    ? moment(
                                                        data.paymentDate
                                                      ).format("DD-MM-YYYY")
                                                    : ""}
                                                </p>
                                              </td>
                                              <td
                                                className={
                                                  "table-cash-bank-data p-2"
                                                }
                                              >
                                                <p
                                                  style={{
                                                    fontFamily: "Poppins",
                                                  }}
                                                >
                                                  {prefix_settings_list &&
                                                  !isEmpty(
                                                    prefix_settings_list.prefixName
                                                  ) &&
                                                  data.paymentNo
                                                    ? data.paymentNo
                                                    : data.paymentNo}
                                                </p>
                                              </td>

                                              <td
                                                className={
                                                  "table-cash-bank-data-amount"
                                                }
                                              >
                                                <div className="flex justify-center">
                                                  <div className="flex">
                                                    <p className="mr-1">
                                                      {"₹ "}
                                                    </p>
                                                    <p
                                                      style={{
                                                        fontFamily: "Poppins",
                                                      }}
                                                    >
                                                      {data.paidAmount
                                                        ? data.paidAmount.toLocaleString(
                                                            "en-IN"
                                                          )
                                                        : 0}
                                                    </p>
                                                  </div>
                                                </div>
                                              </td>
                                              <td
                                                className={
                                                  // downloadLoading
                                                  //   ? "table-cash-bank-data-amount pt-2 pb-2 pr-1 pl-1 text-end"
                                                  //   :
                                                  "table-cash-bank-data-amount"
                                                }
                                              >
                                                <div className="flex justify-center">
                                                  <div className="flex">
                                                    <p className="mr-1">
                                                      {"₹ "}
                                                    </p>
                                                    <p
                                                      style={{
                                                        fontFamily: "Poppins",
                                                      }}
                                                    >
                                                      {data.receivedAmount
                                                        ? data.receivedAmount.toLocaleString(
                                                            "en-IN"
                                                          )
                                                        : 0}
                                                    </p>
                                                  </div>
                                                </div>
                                              </td>
                                              <td
                                                className={
                                                  "table-cash-bank-data-amount p-2"
                                                }
                                              >
                                                <div className="flex justify-center">
                                                  <div className="flex">
                                                    <p className="mr-1">
                                                      {"₹ "}
                                                    </p>
                                                    <p
                                                      style={{
                                                        fontFamily: "Poppins",
                                                      }}
                                                    >
                                                      {data.balanceAmount
                                                        ? data.balanceAmount.toLocaleString(
                                                            "en-IN"
                                                          )
                                                        : 0}
                                                    </p>
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )
                                    : selectedCashInLoad == true && (
                                        <tr key={0}>
                                          <td
                                            colSpan={6}
                                            className="text-center pt-3"
                                          >
                                            <Spin size="large" />
                                          </td>
                                        </tr>
                                      )}
                                </tbody>
                              </table>
                            </Col>
                          ) : (
                            <Col span={24} className="p-2 flex justify-center">
                              <div className="text-center">
                                <Image
                                  src={noTransaction}
                                  preview={false}
                                  width={100}
                                  height={70}
                                />
                                <div className="text-center">
                                  <h1
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="font-medium text-[18px]"
                                  >
                                    No Transactions
                                  </h1>
                                  <p className="cash-label text-[14px]">
                                    Vouchers created with payment mode as Cash
                                    will be displayed here
                                  </p>
                                </div>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </Col>
                    ) : selectedTransaction === "Savings" ? (
                      <Col span={24}>
                        <Row>
                          {transactionRows && transactionRows.length > 0 ? (
                            <Col
                              span={24}
                              className="p-4 overflow overflow-auto"
                            >
                              <table className="w-[100%] mb-[5rem] table-cash-bank table-responsive">
                                <thead>
                                  <tr className="table-cash-bank-head-main">
                                    <th className="w-[5%] uppercase table-cash-bank-head text-[12px] font-semibold">
                                      S.No
                                    </th>
                                    <th className="w-[20%] uppercase table-cash-bank-head text-[12px] font-semibold">
                                      Payment Date
                                    </th>
                                    <th className="w-[20%] uppercase table-cash-bank-head text-[12px] font-semibold">
                                      Payment No
                                    </th>
                                    <th className="w-[15%] uppercase table-cash-bank-head text-[12px] font-semibold">
                                      Paid Amount
                                    </th>
                                    <th className="w-[20%] uppercase table-cash-bank-head text-[12px] font-semibold">
                                      Received Amount
                                    </th>
                                    <th className="w-[20%] uppercase text-end table-cash-bank-head text-[12px] font-semibold">
                                      Balance Amount
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="mb-8">
                                  {transactionRows &&
                                  transactionRows.length > 0 &&
                                  !selectedBankLoad ? (
                                    transactionRows.map((data, index) => {
                                      return (
                                        <tr
                                          key={index}
                                          className={
                                            "table-cash-bank-row border border-b-1 border-x-0 border-t-0"
                                          }
                                        >
                                          <td
                                            className={
                                              "table-cash-bank-data p-2"
                                            }
                                          >
                                            {index + 1}
                                          </td>
                                          <td
                                            className={
                                              "table-cash-bank-data p-2"
                                            }
                                          >
                                            <p
                                              style={{
                                                fontFamily: "Poppins",
                                              }}
                                            >
                                              {" "}
                                              {data.paymentDate
                                                ? moment(
                                                    data.paymentDate
                                                  ).format("DD-MM-YYYY")
                                                : ""}
                                            </p>
                                          </td>
                                          <td
                                            className={
                                              "table-cash-bank-data p-2"
                                            }
                                          >
                                            <p
                                              style={{
                                                fontFamily: "Poppins",
                                              }}
                                            >
                                              {prefix_settings_list &&
                                              !isEmpty(
                                                prefix_settings_list.prefixName
                                              ) &&
                                              data.paymentNo
                                                ? data.paymentNo
                                                : data.paymentNo}
                                            </p>
                                          </td>

                                          <td
                                            className={
                                              "table-cash-bank-data-amount"
                                            }
                                          >
                                            <div className="flex justify-center">
                                              <div className="flex">
                                                <p className="mr-1">{"₹ "}</p>
                                                <p
                                                  style={{
                                                    fontFamily: "Poppins",
                                                  }}
                                                >
                                                  {data.paidAmount
                                                    ? data.paidAmount.toLocaleString(
                                                        "en-IN"
                                                      )
                                                    : 0}
                                                </p>
                                              </div>
                                            </div>
                                          </td>
                                          <td
                                            className={
                                              // downloadLoading
                                              //   ? "table-cash-bank-data-amount pt-2 pb-2 pr-1 pl-1 text-end"
                                              //   :
                                              "table-cash-bank-data-amount"
                                            }
                                          >
                                            <div className="flex justify-center">
                                              <div className="flex">
                                                <p className="mr-1">{"₹ "}</p>
                                                <p
                                                  style={{
                                                    fontFamily: "Poppins",
                                                  }}
                                                >
                                                  {data.receivedAmount
                                                    ? data.receivedAmount.toLocaleString(
                                                        "en-IN"
                                                      )
                                                    : 0}
                                                </p>
                                              </div>
                                            </div>
                                          </td>
                                          <td
                                            className={
                                              "table-cash-bank-data-amount p-2"
                                            }
                                          >
                                            <div className="flex justify-center">
                                              <div className="flex">
                                                <p className="mr-1">{"₹ "}</p>
                                                <p
                                                  style={{
                                                    fontFamily: "Poppins",
                                                  }}
                                                >
                                                  {data.balanceAmount
                                                    ? data.balanceAmount.toLocaleString(
                                                        "en-IN"
                                                      )
                                                    : 0}
                                                </p>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr key={0}>
                                      <td
                                        colSpan={6}
                                        className="text-center pt-3"
                                      >
                                        <Spin size="large" />
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </Col>
                          ) : (
                            <Col span={24} className="p-2 flex justify-center">
                              <div className="text-center">
                                <Image
                                  src={noTransaction}
                                  preview={false}
                                  width={100}
                                  height={70}
                                />
                                <div className="text-center">
                                  <h1
                                    style={{
                                      fontFamily: "Poppins",
                                    }}
                                    className="font-medium text-[18px]"
                                  >
                                    No Transactions
                                  </h1>
                                  <p className="cash-label text-[14px]">
                                    Vouchers created with payment mode as
                                    Cheque/ Online will be displayed here
                                  </p>
                                </div>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </Col>
                    ) : (
                      <>
                        <Col span={24} id="cash-total-transaction">
                          <Row>
                            {totalTransactionRows &&
                            totalTransactionRows.length > 0 ? (
                              <Col
                                span={24}
                                className="p-4 overflow overflow-auto"
                              >
                                <table className="w-[100%] mb-[5rem] table-cash-bank table-responsive">
                                  <thead>
                                    <tr className="table-cash-bank-head-main">
                                      <th className="w-[5%] uppercase table-cash-bank-head text-[12px] font-semibold">
                                        S.No
                                      </th>
                                      <th className="w-[20%] uppercase table-cash-bank-head text-[12px] font-semibold">
                                        Payment Date
                                      </th>
                                      <th className="w-[20%] uppercase table-cash-bank-head text-[12px] font-semibold">
                                        Payment No
                                      </th>
                                      <th className="w-[15%] uppercase table-cash-bank-head text-[12px] font-semibold">
                                        Paid Amount
                                      </th>
                                      <th className="w-[20%] uppercase table-cash-bank-head text-[12px] font-semibold">
                                        Received Amount
                                      </th>
                                      <th className="w-[20%] uppercase text-end table-cash-bank-head text-[12px] font-semibold">
                                        Balance Amount
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody className="mb-8">
                                    {totalTransactionRows &&
                                    totalTransactionRows.length > 0 ? (
                                      totalTransactionRows.map(
                                        (data, index) => {
                                          return (
                                            <tr
                                              key={index}
                                              className={
                                                "table-cash-bank-row border border-b-1 border-x-0 border-t-0"
                                              }
                                            >
                                              <td
                                                className={
                                                  "table-cash-bank-data p-2"
                                                }
                                              >
                                                {index + 1}
                                              </td>
                                              <td
                                                className={
                                                  "table-cash-bank-data p-2"
                                                }
                                              >
                                                <p
                                                  style={{
                                                    fontFamily: "Poppins",
                                                  }}
                                                >
                                                  {" "}
                                                  {data.paymentDate
                                                    ? moment(
                                                        data.paymentDate
                                                      ).format("DD-MM-YYYY")
                                                    : ""}
                                                </p>
                                              </td>
                                              <td
                                                className={
                                                  "table-cash-bank-data p-2"
                                                }
                                              >
                                                <p
                                                  style={{
                                                    fontFamily: "Poppins",
                                                  }}
                                                >
                                                  {prefix_settings_list &&
                                                  !isEmpty(
                                                    prefix_settings_list.prefixName
                                                  ) &&
                                                  data.paymentNo
                                                    ? data.paymentNo
                                                    : data.paymentNo}
                                                </p>
                                              </td>

                                              <td
                                                className={
                                                  "table-cash-bank-data-amount"
                                                }
                                              >
                                                <div className="flex justify-center">
                                                  <div className="flex">
                                                    <p className="mr-1">
                                                      {"₹ "}
                                                    </p>
                                                    <p
                                                      style={{
                                                        fontFamily: "Poppins",
                                                      }}
                                                    >
                                                      {data.paidAmount
                                                        ? data.paidAmount.toLocaleString(
                                                            "en-IN"
                                                          )
                                                        : 0}
                                                    </p>
                                                  </div>
                                                </div>
                                              </td>
                                              <td
                                                className={
                                                  // downloadLoading
                                                  //   ? "table-cash-bank-data-amount pt-2 pb-2 pr-1 pl-1 text-end"
                                                  //   :
                                                  "table-cash-bank-data-amount"
                                                }
                                              >
                                                <div className="flex justify-center">
                                                  <div className="flex">
                                                    <p className="mr-1">
                                                      {"₹ "}
                                                    </p>
                                                    <p
                                                      style={{
                                                        fontFamily: "Poppins",
                                                      }}
                                                    >
                                                      {data.receivedAmount
                                                        ? data.receivedAmount.toLocaleString(
                                                            "en-IN"
                                                          )
                                                        : 0}
                                                    </p>
                                                  </div>
                                                </div>
                                              </td>
                                              <td
                                                className={
                                                  "table-cash-bank-data-amount p-2"
                                                }
                                              >
                                                <div className="flex justify-center">
                                                  <div className="flex">
                                                    <p className="mr-1">
                                                      {"₹ "}
                                                    </p>
                                                    <p
                                                      style={{
                                                        fontFamily: "Poppins",
                                                      }}
                                                    >
                                                      {data.balanceAmount
                                                        ? data.balanceAmount.toLocaleString(
                                                            "en-IN"
                                                          )
                                                        : 0}
                                                    </p>
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )
                                    ) : (
                                      <tr key={0}>
                                        <td
                                          colSpan={6}
                                          className="text-center pt-3"
                                        >
                                          <Spin size="large" />
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </Col>
                            ) : (
                              <Col
                                span={24}
                                className="p-2 flex justify-center"
                              >
                                <div className="text-center">
                                  <Image
                                    src={noTransaction}
                                    preview={false}
                                    width={100}
                                    height={70}
                                  />
                                  <div className="text-center">
                                    <h1
                                      style={{
                                        fontFamily: "Poppins",
                                      }}
                                      className="font-medium text-[18px]"
                                    >
                                      No Transactions
                                    </h1>
                                    <p className="cash-label text-[14px]">
                                      You don't have any transaction in selected
                                      period
                                    </p>
                                  </div>
                                </div>
                              </Col>
                            )}
                          </Row>
                        </Col>
                      </>
                    )}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        {/* Adjust Stock Quantity modal */}
        <Modal
          open={addMoneyModal}
          title="Adjust Balance"
          onOk={() => addOrReduceMoneyDetails()}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          okButtonProps={{
            disabled: isButtonDisabled ? true : false,
          }}
          width={450}
          className="mt-[-95px]"
          onCancel={() => setAddMoneyModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ marginTop: "2px", width: "112%", marginLeft: "-24px" }}
          />
          <Row className="mt-[-10px] mb-[-18px]">
            <Col span={24} className="mb-2">
              <Typography className="mb-1 cash-label">
                Adjust Money In
              </Typography>
              <Select
                className="h-[40px] w-[100%]"
                value={addMoneyIn}
                onChange={(e) => {
                  setAddMoneyIn(e);
                  dispatch(
                    loadPartyAccountList({
                      organizationId: organizationId,
                    })
                  );
                  setAccountDetails([]);
                }}
                options={
                  recordsMetaData ? recordsMetaData.paymentModeOptions : []
                }
                placeholder="Select Adjust Money"
              />
            </Col>
            {addMoneyIn === "Cash" &&
            adjustBalanceData.paymentModeId === "66c9bd5ab3fca462ca48a87e"
              ? ""
              : addMoneyIn && (
                  <Col span={24} className="mb-2">
                    <Typography className="flex cash-label">
                      Account <p className="text-[red] ml-1">*</p>
                    </Typography>
                    <Select
                      className="h-[40px] w-[100%]"
                      value={accountDetails}
                      onChange={(e) => setAccountDetails(e)}
                      options={partyAccountList}
                      placeholder="Select Account List"
                    />
                    {validations == true &&
                    addMoneyIn !== "Cash" &&
                    (isEmpty(accountDetails) || accountDetails.length == 0) ? (
                      <p className="text-[red] text-[12px]">
                        The account field is required
                      </p>
                    ) : (
                      ""
                    )}
                  </Col>
                )}

            <Col span={24} className="mb-2 mt-2">
              <Typography className="mb-2 cash-label">Add Or Reduce</Typography>

              <Radio.Group
                className="w-[100%]"
                value={adjustMode}
                onChange={(e) => setAdjustMode(e.target.value)}
              >
                <Radio
                  value={"Add"}
                  className="w-[40%] p-2 rounded-md border border-1"
                >
                  + Add Money
                </Radio>
                <Radio
                  value={"Reduce"}
                  className="w-[40%] ml-2 p-2 rounded-md border border-1"
                >
                  - Reduce Money
                </Radio>
              </Radio.Group>
              {validations == true && isEmpty(adjustMode) ? (
                <p className="text-[red] text-[12px]">
                  The adjust mode field is required
                </p>
              ) : (
                ""
              )}
            </Col>
            <Col span={12} className="pr-2 mt-1 mb-2">
              <Typography className="mb-2 cash-label">
                Current Balance
              </Typography>
              <h1 className="text-[13px]">
                ₹ {adjustBalanceData.currentBalance}
              </h1>
            </Col>
            <Col span={12} className="pr-2 mt-1 mb-2">
              <Typography className="purchase-label mb-1 flex">Date</Typography>

              <DatePicker
                selected={adjustDate}
                className="rounded-md w-[95%] mt-[-3px] border border-1 h-[40px]"
                onChange={(date) => {
                  setAdjustDate(date);
                }}
                icon={
                  <BiCalendar
                    //   size={30}
                    className="top-[2px] text-[16px] right-[10px] text-[#9e9e9e]"
                  />
                }
                toggleCalendarOnIconClick={true}
                style={{
                  fontFamily: "Poppins",
                }}
                showIcon={true}
                placeholderText="Select Date"
              />
              {/* {validations == true && adjustDate !== '' ? (
                <p className="text-[red] text-[12px]">
                  The adjust date field is required
                </p>
              ) : (
                ""
              )} */}
            </Col>

            <Col span={24} className="mb-2 pr-2">
              <Typography className="text-[blue] mb-2 cash-label">
                Enter Amount
              </Typography>
              <Input
                name="adjustAmount"
                value={adjustBalanceData.adjustAmount}
                placeholder="0.0"
                onChange={(e) => handleAdjustChange(e)}
                className="h-[45px] border-none border-b-1"
                addonBefore={
                  <div className="flex">
                    {adjustMode === "Reduce" ? (
                      <MinusOutlined className="text-[14px] text-[red]" />
                    ) : (
                      <PlusOutlined className="text-[14px] text-[green]" />
                    )}
                    <p className="ml-1 text-[16px] font-bold">₹</p>
                  </div>
                }
              />
              {validations == true &&
              isEmpty(adjustBalanceData.adjustAmount) ? (
                <p className="text-[red] text-[12px]">
                  The adjust amount field is required
                </p>
              ) : (
                ""
              )}
            </Col>
            <Col span={24} className="mb-2 ">
              <Typography className="mb-1 cash-label">
                New Balance:{" ₹ "}
                {!isEmpty(adjustBalanceData.adjustAmount) &&
                adjustMode === "Reduce"
                  ? parseInt(adjustBalanceData.currentBalance) - adjustAmount
                  : !isEmpty(adjustBalanceData.adjustAmount) &&
                    adjustMode === "Add"
                  ? adjustAmount + adjustBalanceData.currentBalance
                  : 0}
              </Typography>
            </Col>
            <Col span={24} className="">
              <Typography className="mb-2 cash-label">Remarks</Typography>
              <Input.TextArea
                name="adjustRemarks"
                value={adjustBalanceData.adjustRemarks}
                placeholder="Enter Remarks"
                onChange={(e) => handleAdjustChange(e)}
                className="p-2"
                suffix={"PCS"}
              />
            </Col>
          </Row>
          <Divider style={{ width: "112%", marginLeft: "-24px" }} />
        </Modal>

        {/* Add, edit account details */}
        <Modal
          open={addBankModal}
          title={"Edit Bank Account"}
          onOk={() => {
            const updatedAtDate =
              selectedBankAccount.updatedAt !== undefined ||
              selectedBankAccount.updatedAt !== null
                ? moment(selectedBankAccount.updatedAt).format("YYYY-MM-DD")
                : "";
            console.log(updatedAtDate, "updatedAtDate");
            setAddBankModal(false);
            setUpdateBankModal(true);
            setBankMode("Edit");
            setAsOfDate(updatedAtDate);
            setBankData({
              accountName: selectedBankAccount.accountName,
              openingBalance: selectedBankAccount.openingBalance,
              currentBalance: selectedBankAccount.currentBalance,
              accountNumber: selectedBankAccount.accountNumber,
              reAccountNumber: "",
              ifscCode: selectedBankAccount.ifscCode,
              bankName: selectedBankAccount.bankName,
              bankBranchName: selectedBankAccount.bankBranch,
              accountHoldersName: selectedBankAccount.accountHolderName,
              upiId: selectedBankAccount.upiId,
              _id: selectedBankAccount._id,
            });
          }}
          closeIcon
          maskClosable={false}
          okText={"Edit Bank Details"}
          cancelText={""}
          width={550}
          className="mt-[-55px]"
          onCancel={() => setAddBankModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ marginTop: "2px", width: "112%", marginLeft: "-24px" }}
          />
          <Row className="relative mt-[-10px] mb-[-18px]">
            <Col span={24} className="mb-6">
              <Typography
                style={{
                  fontSize: "14px",
                  fontFamily: "Poppins",
                  color: "#687e96",
                }}
                className="mb-2"
              >
                Accounts Name
              </Typography>
              <p className="text-[14px]">
                {selectedBankAccount && selectedBankAccount.accountName}
              </p>
            </Col>
            <Col span={12} className="mb-6 ">
              <div>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontFamily: "Poppins",
                    color: "#687e96",
                  }}
                  className="mb-2"
                >
                  Bank Account Number
                </Typography>
                <p className="text-[14px]">
                  {selectedBankAccount && selectedBankAccount.accountNumber}
                </p>
              </div>
            </Col>
            <Col span={12} className="mb-6">
              <div>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontFamily: "Poppins",
                    color: "#687e96",
                  }}
                  className="mb-2"
                >
                  IFSC Code
                </Typography>
                <p className="text-[14px]">
                  {selectedBankAccount && selectedBankAccount.ifscCode}
                </p>
              </div>
            </Col>
            <Col span={12} className="mb-6">
              <div>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontFamily: "Poppins",
                    color: "#687e96",
                  }}
                  className="mb-2"
                >
                  Bank & Branch
                </Typography>

                <p className="text-[black] ml-1">
                  {" "}
                  {!isEmpty(selectedBankAccount.bankName) &&
                  !isEmpty(selectedBankAccount.bankBranch)
                    ? `${
                        selectedBankAccount.bankName +
                        " & " +
                        selectedBankAccount.bankBranch
                      }`
                    : ""}
                </p>
              </div>
            </Col>
            <Col span={12} className="mb-6">
              <div>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontFamily: "Poppins",
                    color: "#687e96",
                  }}
                  className="mb-2"
                >
                  Account Holders Name
                </Typography>
                <p
                  style={{
                    fontSize: "13px",
                    fontFamily: "Poppins",
                  }}
                >
                  {selectedBankAccount.accountHolderName
                    ? selectedBankAccount.accountHolderName
                    : ""}
                </p>
              </div>
            </Col>
            <div className="absolute text-[#687e96] bottom-[-50px] text-[16px]">
              <EyeInvisibleOutlined className="text-[14px]" /> Deactivate
              Account
            </div>
          </Row>
          <Divider
            style={{
              borderWidth: "0.2px",
              marginBottom: "-2px",
              width: "109.5%",
              marginLeft: "-24px",
            }}
          />
        </Modal>

        {/* update account details */}
        <Modal
          open={updateBankModal}
          title={
            bankMode === "Edit" ? "Update Bank Account" : "Add Bank Account"
          }
          onOk={bankMode === "Edit" ? updateBankDetails : createBankDetails}
          closeIcon
          maskClosable={false}
          okText={
            bankMode == "Edit" ? "Update Bank Details" : "Add Bank Details"
          }
          okButtonProps={{
            disabled: isBankButtonDisabled ? true : false,
          }}
          cancelText={""}
          width={550}
          className="mt-[-88px] overflow-hidden"
          onCancel={() => setUpdateBankModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ marginTop: "2px", width: "112%", marginLeft: "-24px" }}
          />
          <Row className="relative mt-[-13px] mb-[-18px]">
            <Col span={24} className="mb-2 pr-2">
              <Typography
                style={{
                  fontSize: "14px",
                  fontFamily: "Poppins",
                  color: "#687e96",
                }}
                className="flex mb-[3px]"
              >
                Account Name <p className="text-[red] text-[12px] mr-2">*</p>
              </Typography>
              <Input
                name="accountName"
                value={bankData.accountName}
                placeholder="Enter Account Name"
                onChange={(e) => handleBankChange(e)}
                className="h-[40px]"
              />
              <p className="text-[11px] text-[red]">
                {simpleValidator.current.message(
                  "accountName",
                  bankData.accountName,
                  "required"
                )}
              </p>
            </Col>
            <Col span={12} className="mb-2 pr-2">
              <Typography
                style={{
                  fontSize: "14px",
                  fontFamily: "Poppins",
                  color: "#687e96",
                }}
                className="flex mb-[3px]"
              >
                Opening Balance <p className="text-[red] text-[12px] mr-2">*</p>
              </Typography>
              <Input
                name="openingBalance"
                value={bankData.openingBalance}
                placeholder="Enter Opening Balance"
                onChange={(e) => handleBankChange(e)}
                className="h-[40px]"
              />
              <p className="text-[11px] text-[red]">
                {simpleValidator.current.message(
                  "openingBalance",
                  bankData.openingBalance,
                  "required"
                )}
              </p>
            </Col>
            <Col span={12} className="pr-2 mt-1 mb-2">
              <Typography
                style={{
                  fontSize: "14px",
                  fontFamily: "Poppins",
                  color: "#687e96",
                }}
                className="mb-1"
              >
                Date
              </Typography>

              <DatePicker
                selected={asOfDate}
                className="rounded-md w-[95%] mt-[3px] border border-1 h-[40px]"
                onChange={(date) => setAsOfDate(date)}
                icon={
                  <BiCalendar
                    //   size={30}
                    className="top-[4px] text-[16px] right-[10px] text-[#9e9e9e]"
                  />
                }
                style={{
                  fontFamily: "Poppins",
                }}
                toggleCalendarOnIconClick={true}
                popperClassName={
                  bankDetailsChecked == false ? "z-10000 mt-14" : "z-10000 mt-3"
                }
                showIcon={true}
                popperPlacement="bottom-start"
                placeholderText="Select Date"
              />
            </Col>

            <Col span={24} className="mb-2 mt-2">
              <Row className="flex justify-between w-[109.5%] ml-[-24px] bg-gray-50 p-1 border border-x-0 pl-5 pr-5">
                <h1 className="text-[16px] text-[#084d7b] font-semibold">
                  Add Bank Details
                </h1>
                <Switch
                  value={bankDetailsChecked}
                  onChange={(checked) => setBankDetailsChecked(checked)}
                />
              </Row>
            </Col>
            {bankDetailsChecked ? (
              <>
                {" "}
                <Col span={12} className="mb-1 mt-2 pr-2">
                  <Typography
                    style={{
                      fontSize: "14px",
                      fontFamily: "Poppins",
                      color: "#687e96",
                    }}
                    className="mb-1 flex "
                  >
                    Bank Account Number{" "}
                    {/* <p className="text-[red] text-[12px] mr-2">*</p> */}
                  </Typography>
                  <Input
                    name="accountNumber"
                    value={bankData.accountNumber}
                    placeholder="Enter Bank Account Number"
                    onChange={(e) => handleBankChange(e)}
                    className="h-[40px]"
                  />
                </Col>
                {/* <Col span={12} className="mb-1 mt-2 pr-2">
              <Typography
                style={{
                  fontSize: "14px",
                  fontFamily: "Poppins",
                  color: "#687e96",
                }}
                className="mb-2 flex "
              >
                Re-Enter Bank Account Number{" "}
                <p className="text-[red] text-[12px] mr-2">*</p>
              </Typography>
              <Input
                name="reAccountNumber"
                value={bankData.reAccountNumber}
                placeholder="Enter Bank Account Number"
                onChange={(e) => handleBankChange(e)}
                className="h-[40px]"
              />
            </Col> */}
                <Col span={12} className="mb-1 mt-2 pr-2">
                  <Typography
                    style={{
                      fontSize: "14px",
                      fontFamily: "Poppins",
                      color: "#687e96",
                    }}
                    className="flex mb-1"
                  >
                    IFSC Code
                  </Typography>
                  <Input
                    name="ifscCode"
                    value={bankData.ifscCode}
                    placeholder="Enter IFSC Code"
                    onChange={(e) => handleBankChange(e)}
                    className="h-[40px]"
                  />
                </Col>
                <Col span={12} className="mb-1 mt-2 pr-2">
                  <Typography
                    style={{
                      fontSize: "14px",
                      fontFamily: "Poppins",
                      color: "#687e96",
                    }}
                    className="mb-1 flex "
                  >
                    Bank Name
                  </Typography>
                  <Input
                    name="bankName"
                    value={bankData.bankName}
                    placeholder="Enter Bank & Branch Name"
                    onChange={(e) => handleBankChange(e)}
                    className="h-[40px]"
                  />
                  {/* <p className="text-[11px] text-[red]">
                    {simpleValidator.current.message(
                      "bankName",
                      bankData.bankName,
                      "required"
                    )}
                  </p> */}
                </Col>
                <Col span={12} className="mb-1 mt-2 pr-2">
                  <Typography
                    style={{
                      fontSize: "14px",
                      fontFamily: "Poppins",
                      color: "#687e96",
                    }}
                    className="mb-1 flex "
                  >
                    Branch Name
                    {/* <p className="text-[red] text-[12px] mr-2">*</p> */}
                  </Typography>
                  <Input
                    name="bankBranchName"
                    value={bankData.bankBranchName}
                    placeholder="Enter Branch Name"
                    onChange={(e) => handleBankChange(e)}
                    className="h-[40px]"
                  />
                  {/* <p className="text-[11px] text-[red]">
                    {simpleValidator.current.message(
                      "bankBranchName",
                      bankData.bankBranchName,
                      "required"
                    )}
                  </p> */}
                </Col>
                <Col span={12} className="mb-1 mt-2 pr-2">
                  <Typography
                    style={{
                      fontSize: "14px",
                      fontFamily: "Poppins",
                      color: "#687e96",
                    }}
                    className="flex "
                  >
                    Account Holders Name{" "}
                    {/* <p className="text-[red] text-[12px] mr-2">*</p> */}
                  </Typography>
                  <Input
                    name="accountHoldersName"
                    value={bankData.accountHoldersName}
                    placeholder="Enter Account Holders Name"
                    onChange={(e) => handleBankChange(e)}
                    className="h-[40px]"
                  />
                  {/* <p className="text-[11px] text-[red]">
                    {simpleValidator.current.message(
                      "accountHoldersName",
                      bankData.accountHoldersName,
                      "required"
                    )}
                  </p> */}
                </Col>
                <Col span={12} className="mb-1 mt-2 pr-2">
                  <Typography
                    style={{
                      fontSize: "14px",
                      fontFamily: "Poppins",
                      color: "#687e96",
                    }}
                    className="mb-1"
                  >
                    UPI ID
                  </Typography>
                  <Input
                    name="upiId"
                    value={bankData.upiId}
                    placeholder="Enter UPI Id"
                    onChange={(e) => handleBankChange(e)}
                    className="h-[40px]"
                  />
                </Col>
              </>
            ) : (
              ""
            )}
          </Row>
          <Divider
            style={{
              borderWidth: "0.2px",
              marginBottom: "-2px",
              width: "109.5%",
              marginLeft: "-24px",
            }}
          />
        </Modal>

        {/* Share account details */}
        <Modal
          open={shareAccountModal}
          title="Share Account Details"
          onOk={() => setShareAccountModal(false)}
          closeIcon
          maskClosable={false}
          okText={"Share Details"}
          okButtonProps={{
            disabled: true,
          }}
          width={550}
          className="mt-[-55px]"
          onCancel={() => setShareAccountModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ marginTop: "2px", width: "112%", marginLeft: "-24px" }}
          />
          <Row className="mt-[-10px] mb-[-18px]">
            <Col span={24} className="mb-2">
              <Typography className="mb-2 cash-label">
                Account Holder Name
              </Typography>
              <p className="text-[14px]">
                {selectedBankAccount && selectedBankAccount.accountHolderName}
              </p>
              <Divider
                style={{
                  marginBottom: "-2px",
                  width: "112%",
                  marginLeft: "-24px",
                }}
              />
            </Col>
            <Col span={24} className="mb-2 ">
              <div className="flex justify-between ">
                <div>
                  <Typography className="mb-2 cash-label">
                    Account Number
                  </Typography>
                  <p className="text-[14px]">
                    {selectedBankAccount && selectedBankAccount.accountNumber}
                  </p>
                </div>

                <div
                  onClick={() => {
                    setSelectMode("Account");
                    // setSelectedText(selectedBankAccount.accountNumber);
                    handleCopy(selectedBankAccount.accountNumber);
                  }}
                  className="text-[12px] text-[blue] font-semibold border mb-2 mt-1 rounded-md p-1 pl-3 pr-3 pt-2 cursor-pointer"
                >
                  {copiedText && selectMode == "Account" ? "Copied!" : "COPY"}
                </div>
              </div>
              <Divider
                style={{
                  marginBottom: "-2px",
                  width: "112%",
                  marginLeft: "-24px",
                }}
              />
            </Col>
            <Col span={24} className="mb-2 ">
              <div className="flex justify-between ">
                <div>
                  <Typography className="mb-2 cash-label">IFSC Code</Typography>
                  <p className="text-[14px]">
                    <p className="text-[black] ml-1">
                      {selectedBankAccount.ifscCode
                        ? selectedBankAccount.ifscCode
                        : ""}
                    </p>
                  </p>
                </div>

                <div
                  onClick={() => {
                    setSelectMode("Ifsc");
                    handleCopy(selectedBankAccount.ifscCode);
                  }}
                  className="text-[12px] text-[blue] font-semibold border mb-2 mt-1 rounded-md p-1 pl-3 pr-3 pt-2 cursor-pointer"
                >
                  {copiedText && selectMode == "Ifsc" ? "Copied!" : "COPY"}
                </div>
              </div>
              <Divider
                style={{
                  marginBottom: "-2px",
                  width: "112%",
                  marginLeft: "-24px",
                }}
              />
            </Col>
            <Col span={24} className="mb-2">
              <div className="flex justify-between ">
                {" "}
                <div>
                  <Typography className="mb-2 cash-label">
                    Bank & Branch
                  </Typography>
                  <p className="text-[black] ml-1">
                    {" "}
                    {!isEmpty(selectedBankAccount.bankName) &&
                    !isEmpty(selectedBankAccount.bankBranch)
                      ? `${
                          selectedBankAccount.bankName +
                          " & " +
                          selectedBankAccount.bankBranch
                        }`
                      : ""}
                  </p>
                </div>
                <div
                  onClick={() => {
                    setSelectMode("Bank Branch");
                    handleCopy(
                      !isEmpty(selectedBankAccount.bankName) &&
                        !isEmpty(selectedBankAccount.bankBranch)
                        ? `${
                            selectedBankAccount.bankName +
                            " & " +
                            selectedBankAccount.bankBranch
                          }`
                        : ""
                    );
                  }}
                  className="text-[12px] text-[blue] font-semibold border mb-2 mt-1 rounded-md p-1 pl-3 pr-3 pt-2 cursor-pointer"
                >
                  {copiedText && selectMode == "Bank Branch"
                    ? "Copied!"
                    : "COPY"}
                </div>
              </div>
            </Col>
          </Row>
          <Divider
            style={{
              borderWidth: "0.2px",
              marginBottom: "-2px",
              width: "109.5%",
              marginLeft: "-24px",
            }}
          />
        </Modal>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

export default CasbBank;
